import {
  SelectInput,
  SelectInputProps,
} from "@/lib/Components/Form/Inputs/SelectInput";
import { RelocationInclusionType } from "@/gql/graphql";
import { SelectOption } from "@/lib/Components/Form/Components/Select";

export function RelocationInclusionTypeInput({
  excludeTypes = [],
  ...props
}: Omit<SelectInputProps<any>, "options"> & {
  excludeTypes?: RelocationInclusionType[];
}) {
  const options: {
    [key in RelocationInclusionType]: SelectOption;
  } = {
    [RelocationInclusionType.Negative]: {
      label: "Negative",
      value: RelocationInclusionType.Negative,
    },
    [RelocationInclusionType.Charge]: {
      label: "Charge",
      value: RelocationInclusionType.Charge,
    },
    [RelocationInclusionType.Ferry]: {
      value: RelocationInclusionType.Ferry,
      label: "Ferry",
    },
    [RelocationInclusionType.Fuel]: {
      value: RelocationInclusionType.Fuel,
      label: "Fuel",
    },
    [RelocationInclusionType.Other]: {
      value: RelocationInclusionType.Other,
      label: "Other",
    },
  };

  const isIncluded = (type: RelocationInclusionType) =>
    !excludeTypes.includes(type);

  const groups = [
    {
      label: "positive",
      types: [
        RelocationInclusionType.Ferry,
        RelocationInclusionType.Fuel,
        RelocationInclusionType.Other,
      ],
    },
    {
      label: "negative",
      types: [RelocationInclusionType.Negative, RelocationInclusionType.Charge],
    },
  ];

  return (
    <SelectInput
      {...props}
      options={groups
        .map((group) => ({
          label: group.label,
          options: group.types.filter(isIncluded).map((type) => options[type]),
        }))
        .filter((group) => group.options.length > 0)}
    />
  );
}
